import Vue from 'vue'
import gButton from './button.vue'



new Vue({
  el:"#app",
  components:{
    gButton
  }
})